<script setup lang="ts">
import type { RouterLinkProps } from "vue-router";

const props = defineProps<RouterLinkProps>();
</script>

<template>
  <RouterLink v-bind="{ props }" :to="props.to">
    <slot />
  </RouterLink>
</template>

<style scoped lang="scss"></style>
